import React from "react";
import { Urls } from "../../constants/UrlConstants";
import thriveLogoForHOL from "../../assets/img/banners/Thrive_logo_HOL.png";
import { RebrandHelper } from "../../helpers/brand/RebrandHelper";

const coronavirusLink = (
  <a
    href={Urls.AXACovidInfo}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Coronovirus support"
  >
    coronavirus support
  </a>
);

const brexitLink = (
  <a
    href={Urls.AXABrexitInfo}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Brexit travel"
  >
    Brexit travel
  </a>
);

const thriveTCLink = (
  <p>
    <a
      href={Urls.AXAThriveTC}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Thrive terms and conditions"
    >
      Terms and conditions
    </a>
  </p>
);

export const SpecialInformationSplitBannerContent = {
  useDiffLeftStyling: { MOL: true },
  leftHeadline: {
    MOL: "We're here for you",
    HOL: "Becoming AXA Health"
  },
  leftMessage: {
    MOL: (
      <p>
        Visit our {coronavirusLink} and {brexitLink} pages on the main website.
      </p>
    ),
    HOL: (
      <p>
        We’re bringing our AXA PPP healthcare and Health-on-Line health brands
        together under one name – AXA Health.
        <br />
        While we’re letting you know now, we’ll be working hard over the coming
        months to make this transition, it won’t happen all at once.
        <br />
        In the meantime, we want to be clear about what services we provide to
        you, under each brand, while we make the transition.
      </p>
    )
  },
  leftButtonLabel: { MOL: null, HOL: "Information about AXA Health" },
  leftButtonAriaLabel: { Any: null },
  leftButtonLink: { MOL: null, HOL: Urls.AxaHealthHolAbout },
  rightHeadline: {
    Any: null,
    HOL: { Any: null, Lapsed: "Information about the coronavirus" }
  },
  rightHeadlineSrc: {
    MOL: RebrandHelper.getThriveLogo(),
    HOL: thriveLogoForHOL
  },
  rightHeadlineAlt: {
    MOL: `Thrive together with ${RebrandHelper.getAxaBrandName()}`,
    HOL: "Thrive"
  },
  rightMessage: {
    MOL: (
      <p>
        Good news - we're extending your free access to Thrive! You can now
        access Thrive for free until 31st March 2022. Thrive is an app that
        helps you boost your mental wellbeing, manage your mood and build
        resilience. Download the <strong>Thrive: Mental wellbeing</strong> app
        and sign up using the access code <strong>AXAPPP2020</strong>.
      </p>
    ),
    HOL: {
      Any: (
        <p>
          Good news - we’re extending your free access to Thrive! You can now
          access Thrive for free until 31st March 2022. Thrive is an app that
          helps you boost your mental wellbeing, manage your mood and build
          resilience. Download the <strong>Thrive: Mental wellbeing</strong> app
          and sign up using the access code <strong>HOL2020</strong>.
        </p>
      ),
      Lapsed: `Visit the main ${RebrandHelper.getAxaBrandName()} website for the latest information on the coronavirus.`
    }
  },
  rightTCLink: {
    Any: thriveTCLink,
    HOL: {
      Any: thriveTCLink,
      Lapsed: null
    }
  },
  rightButtonLabel: {
    Any: "How does it work?",
    HOL: { Any: "How does it work?", Lapsed: "Read more about Coronavirus" }
  },
  rightButtonAriaLabel: {
    Any: "How does Thrive work?",
    HOL: { Any: "How does Thrive work?", Lapsed: "Read more about Coronavirus" }
  },
  rightButtonLink: {
    MOL: Urls.AXAThriveHowDoesItWork.MOL,
    HOL: { Any: Urls.AXAThriveHowDoesItWork.HOL, Lapsed: Urls.AXACovidInfo }
  }
};
